import { queryOptions } from '@tanstack/react-query';
import { getActualPromos, getPromoItems } from './freePassApi';

const FREE_PASS_KEY_ROOT = 'free-pass';

export const freePassQueries = {
  all: [FREE_PASS_KEY_ROOT] as const,
  promos: (userId: string) =>
    queryOptions({
      queryKey: [FREE_PASS_KEY_ROOT, 'promos', userId] as const,
      queryFn: getActualPromos,
      staleTime: 5 * 60 * 1000,
    }),
  items: ({ userId, promoId }: { userId: string; promoId: string }) =>
    queryOptions({
      queryKey: [FREE_PASS_KEY_ROOT, 'items', userId, promoId] as const,
      queryFn: () => getPromoItems(promoId),
      staleTime: 30 * 1000,
    }),
  /**
   * Same endpoint as `items`, read anonymously for the reward ladder only.
   *
   * A separate key because the caching is the opposite: there is no user state
   * in an anonymous response, so it is campaign config that cannot change
   * mid-session — cache it forever instead of re-reading every 30s. Sharing
   * `items`' key would let the two policies fight over one cache entry.
   */
  guestItems: (promoId: string) =>
    queryOptions({
      queryKey: [FREE_PASS_KEY_ROOT, 'guest-items', promoId] as const,
      queryFn: () => getPromoItems(promoId),
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
